import { Image, Link, Spinner } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { copyAndformatVisualQuestions } from '@/patient-app-common/helpers/progress_helper';
import Placeholder from '@/assets/images/file-search.png';
import useSurveys from '@/patient-app-common/hooks/useSurveys';
import useTrackers from '@/patient-app-common/hooks/useTrackers';

import { ChartPreview } from './ChartPreview';

export function ChartsList() {
  const { t } = useTranslation('progress');
  const { pathname } = useLocation();
  const { allSurveys, isLoading: isLoadingSurveys } = useSurveys();
  const { surveyEntries, isLoading: isLoadingEntries } = useTrackers();
  const isLoading = isLoadingEntries || isLoadingSurveys;

  const chartQuestions = useMemo(() => {
    if (!surveyEntries?.length || !allSurveys) return [];
    return copyAndformatVisualQuestions(allSurveys, surveyEntries);
  }, [allSurveys, surveyEntries]);

  if (!chartQuestions.length && !isLoading) {
    return (
      <div className="mx-auto w-full md:w-1/2 mt-8">
        <Link href="/progress?tab=surveys">
          <Icon icon="mdi:chevron-left" className="inline-flex" />
          {t('common.action.back')}
        </Link>
        <div className="flex justify-center">
          <div className="text-center w-full">
            <div className="flex justify-center py-8">
              <Image src={Placeholder} alt="" width={400} disableSkeleton />
            </div>
            <h2 className="font-light text-default-600 text-lg">
              {t('chartslist.empty_text')}
            </h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full md:w-1/2 space-y-8 my-12">
      {pathname.includes('/progress') && (
        <Link href="/progress?tab=surveys">
          <Icon icon="mdi:chevron-left" className="inline-flex" />
          {t('common.action.back')}
        </Link>
      )}
      {isLoading && (
        <div className="flex justify-center">
          <Spinner color="primary" size="lg" />
        </div>
      )}
      <ChartPreview chartQuestions={chartQuestions} />
    </div>
  );
}
